import {
  CrmIcon,
  GethealthieIcon,
  HighLevelIcon,
  JunctionIcon,
  ManualIcon,
  MdiIcon,
  OrderIcon,
  QuelloIcon,
  SamcartIcon,
  ShopifyIcon,
  StripeIcon,
  TelegraIcon,
} from '../common/all-icons/custom-icons';

export const USER_HEADER_OFFSET = 80; //same as userNavbar header height

export const REQUEST_TYPES = {
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
  GET: 'get',
  DELETE: 'delete',
};

export const SIDE_MENU_WIDTH = {
  open: 230,
  close: 72,
};

export const FILTER_TYPES = {
  DROP_DOWN: 'dropdown',
  BOOLEAN: 'boolean',
  DATE: 'date',
  INPUT: 'input',
};

export const SYNC_TYPES = Object.freeze({
  MDI: 'mdi',
  SAMCART: 'samcart',
});

export const USERS_MODAL_TYPES = Object.freeze({
  ADD_USER: 'add_user',
  EDIT_USER: 'edit_user',
  DELETE_USER: 'delete_user',
});

export const TEAMS_MODAL_TYPES = Object.freeze({
  ADD_TEAM: 'add_team',
  EDIT_TEAM: 'edit_team',
  DELETE_TEAM: 'delete_team',
});

export const TEMPLATES_MODAL_TYPES = Object.freeze({
  ADD_TEMPLATE: 'add_template',
  DELETE_TEMPLATE: 'delete_template',
  EDIT_TEMPLATE: 'edit_template',
  VIEW_TEMPLATE: 'view_template',
});

export const TOKENS_MODAL_TYPES = Object.freeze({
  ADD_TOKEN: 'add_token',
  EDIT_TOKEN: 'edit_token',
  DELETE_TOKEN: 'delete_token',
});

export const LAB_APPOINTMENT_MODAL_TYPES = Object.freeze({
  CREATE_APPOINTMENT: 'create_appointment',
  VIEW_APPOINTMENT: 'view_appointment',
  RESCHEDULE_APPOINTMENT: 'reschedule_appointment',
  VIEW_INSTRUCTIONS: 'view_instructions',
  CONFIRM_APPOINTMENT: 'confirm_appointment',
  CANCEL_APPOINTMENT: 'cancel_appointment',
});

export const PRODUCT_MODAL_TYPES = Object.freeze({
  EDIT_PRODUCT: 'edit_product',
});

export const ROLES_MODAL_TYPES = Object.freeze({
  ADD_ROLE: 'add_role',
  EDIT_ROLE: 'edit_role',
  DELETE_ROLE: 'delete_role',
});

export const LAB_REVIEW_MODAL_TYPES = Object.freeze({
  ADD_LAB_REVIEW: 'add_lab_review',
  EDIT_LAB_REVIEW: 'edit_lab_review',
  LINK_LAB_ORDER: 'link_lab_order',
  DETACH_LAB_ORDER: 'detach_lab_order',
});

export const ADDRESS_MODAL_TYPES = Object.freeze({
  CREATE_ADDRESS: 'create_address',
  VIEW_ADDRESS: 'view_address',
  EDIT_ADDRESS: 'edit_address',
  DELETE_ADDRESS: 'delete_address',
});

export const SOURCE_CLASS_NAMES = Object.freeze({
  LEAD: 'Lead',
  PATIENT: 'Patient',
  ORDER: 'Order',
  CASE: 'Case',
  STATUS: 'Status',
  TYPE: 'Type',
  PRODUCT: 'Product',
  SUBSCRIPTION: 'Subscription',
  USER: 'User',
  ADMIN_USER: 'AdminUser',
  CLIENT_USER: 'ClientUser',
  TICKET: 'Ticket',
  QUESTIONNAIRES: 'Questionnaire',
  PRODUCT_QUESTIONNAIRE: 'ProductQuestionnaire',
  VOUCHERS: 'Voucher',
  TEAMS: 'Team',
  TOKEN: 'ExternalToken',
  TRACKING: 'PharmacyTracking',
  TEMPLATE: 'template',
  EXPORT: 'export',
  APPOINTMENT: 'appointment',
  FOLLOW_UP: 'followUp',
  ROLE: 'Role',
  LAB_ORDER: 'LabOrder',
  PROMOTION_CODE: 'PromotionCode',
  AGENT_SALES: 'AgentSale',
  QUIZ_ATTEMPTS: 'QuizAttempt',
  SALES_STAT_DETAIL: 'MySale',
  PATIENT_REFERRALS: 'CreditTransaction',
  LAB_REVIEW: 'LabReview',
  PRODUCT_VARIANT: 'ProductVariant',
  CHARGE: 'Charge',
  CONTACT: 'Contact',
  INTAKE: 'Intake',
});

export const LEADS_MESSAGE_TYPE = Object.freeze({
  TYPE_CALL: 'TYPE_CALL',
  TYPE_SMS: 'TYPE_SMS',
  TYPE_EMAIL: 'TYPE_EMAIL',
  TYPE_ACTIVITY_APPOINTMENT: 'TYPE_ACTIVITY_APPOINTMENT',
  TYPE_WEBCHAT: 'TYPE_WEBCHAT',
});

export const weightOptions = [
  { name: 'lb', label: 'Pounds (lb)', value: 1 },
  { name: 'kg', label: 'Kilograms (kg)', value: 2.20462 },
];

export const heightOptions = [
  { name: 'in', label: 'Inches (in)', value: 1 },
  { name: 'ft', label: 'Feet (ft)', value: 12 },
  { name: 'cm', label: 'Centimeters (cm)', value: 0.393701 },
];

export const ADMIN_ROLES = Object.freeze({
  ADMIN: 'admin',
  CRM: 'crm',
});

export const ADMIN_TEAMS = Object.freeze({
  CHAT_SUPPORT: 'chat-support',
});

export const PLATFORMS = Object.freeze({
  ADMIN_WEB: 'admin_web',
  PATIENT_WEB: 'patient_web',
});

export const ORDER_TYPE_ICONS = Object.freeze({
  samcart: <SamcartIcon />,
  shopify: <ShopifyIcon />,
  stripe: <StripeIcon />,
  quello: <QuelloIcon />,
  mdi: <MdiIcon />,
  telegramd: <TelegraIcon />,
  crm: <CrmIcon />,
  highlevel: <HighLevelIcon />,
  manual: <ManualIcon style={{ color: 'var(--ant-color-primary)' }} />,
  internal: <OrderIcon style={{ color: 'var(--ant-color-primary)' }} />,
  gethealthie: <GethealthieIcon />,
  junction_diagnostics: <JunctionIcon />,
  junction: <JunctionIcon />,
});

export const sortKey = 'sort';

export const PERMISSION_TYPE_SLUGS = Object.freeze({
  PERMISSION: 'permission',
  ATTRIBUTE: 'attribute',
});

export const ATTACHMENT_UPLOAD_TYPE = Object.freeze({
  MDI_CHAT_UPLOAD: 'mdi_chat_upload',
});

export const ATTACHMENT_TYPE = Object.freeze({
  CHAT: 'chat_attachment',
  CARD: 'card_attachment',
});

export const LAB_TEST_STATUS = Object.freeze({
  RECEIVED: 'received',
  SAMPLE_WITH_LAB: 'sample_with_lab',
  COMPLETED: 'completed',
  COLLECTING_SAMPLE: 'collecting_sample',
  PARTIAL: 'parital',
});

export const ADDRESS_TYPE = Object.freeze({
  BILLING: 'billing',
  SHIPPING: 'shipping',
});

export const COUPON_DISCOUNT_TYPE = Object.freeze({
  FLAT: 'flat',
  PERCENTAGE: 'percentage',
});

export const TRACKING_URLS = Object.freeze({
  ups: 'http://wwwapps.ups.com/WebTracking/processInputRequest?TypeOfInquiryNumber=T&InquiryNumber1=#{tracking_no}',
  easypost_ups:
    'http://wwwapps.ups.com/WebTracking/processInputRequest?TypeOfInquiryNumber=T&InquiryNumber1=#{tracking_no}',
  easypost_ups_2_day_flat_rate:
    'http://wwwapps.ups.com/WebTracking/processInputRequest?TypeOfInquiryNumber=T&InquiryNumber1=#{tracking_no}',
  fedex: 'https://www.fedex.com/fedextrack/?trknbr=#{tracking_no}',
  stamps_com: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=#{tracking_no}',
});

export const STRIPE_PAYMENT_TYPES = {
  SUBSCRIPTION: 'subscription',
  ONE_TIME: 'one_time',
};

export const USER_DASHBOARD_SECTION_IDS = {
  LAB_ORDER: 'lab_order',
};

export const LAB_REVIEW_STATUSES = {
  APPROVED: 'approved',
  APPROVED_SYNCED: 'approved_synced',
  REJECTED: 'rejected',
  PENDING: 'pending',
};

export const CREDIT_STATUSES = {
  CREDITED: 'credited',
  DEBITED: 'debited',
};

export const CONTACT_TYPE_CONSTANTS = Object.freeze({
  MANUAL: 'manual',
  CRM: 'crm',
  SAMCART: 'samcart',
  MDI: 'mdi',
  HIGHLEVEL: 'highlevel',
  STRIPE: 'stripe',
  JUNCTION: 'junction',
  TELEGRAMD: 'telegramd',
  SHOPIFY: 'shopify',
});

export const TEXT_PRESETS = [
  {
    label: 'Main Colors:',
    colors: [
      '#000000',
      '#434343',
      '#8C8C8C',
      '#BFBFBF',
      '#096DD9',
      '#24A147',
      '#F5222D',
      '#E9D502',
      '#FB5607',
      '#9333EA',
      '#00BBA4',
      '#C02DD7',
      '#E5368C',
      '#6FB800',
    ],
    key: 'default',
  },
];

export const BACKGROUND_PRESETS = [
  {
    label: 'Main Colors:',
    colors: [
      '#F8F8F8',
      '#F0F0F0',
      '#D9D9D9',
      '#BFBFBF',
      '#096DD91A',
      '#E7F2EA',
      '#F5222D1A',
      '#E9D5021F',
      '#FB56071F',
      '#F3E8FF',
      '#2DD4BF1F',
      '#D946EF1F',
      '#EC48991F',
      '#84CC161F',
    ],
    key: 'default',
  },
];

export const REWARD_POINTS = 10;
export const AFFILIATE_REWARD_POINTS = 25;

export const USER_INFO_MODAL_TABS = Object.freeze({
  PERSONAL_INFO: 'Personal Info',
  SHIFTS: 'Shifts',
  LEAVES: 'Leaves',
  DEVICES: 'Devices',
  PREFERENCES: 'Preferences',
});

export const LAB_PANEL_METHODS = Object.freeze({
  TESTKIT: 'Testkit',
});
